module.exports = __webpack_public_path__ + "static/plus-29462b80aab390fb4ff6db64073b3695.png";